var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBathRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66692 8.33467C1.97377 8.33467 2.22252 8.08592 2.22252 7.77908C2.22252 7.47223 1.97377 7.22348 1.66692 7.22348C1.36008 7.22348 1.11133 7.47223 1.11133 7.77908C1.11133 8.08592 1.36008 8.33467 1.66692 8.33467Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88958 8.33467C4.19643 8.33467 4.44518 8.08592 4.44518 7.77908C4.44518 7.47223 4.19643 7.22348 3.88958 7.22348C3.58273 7.22348 3.33398 7.47223 3.33398 7.77908C3.33398 8.08592 3.58273 8.33467 3.88958 8.33467Z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11224 8.33467C6.41908 8.33467 6.66783 8.08592 6.66783 7.77908C6.66783 7.47223 6.41908 7.22348 6.11224 7.22348C5.80539 7.22348 5.55664 7.47223 5.55664 7.77908C5.55664 8.08592 5.80539 8.33467 6.11224 8.33467Z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44477 1.15579V0.000152588H3.33358V1.15579C1.45011 1.42804 0 3.03926 0 5.00052V6.11171H7.77835V5.00052C7.77835 3.03926 6.32825 1.42804 4.44477 1.15579Z",
    fill: "#B9B9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66692 10.0003C1.97377 10.0003 2.22252 9.75155 2.22252 9.4447C2.22252 9.13785 1.97377 8.8891 1.66692 8.8891C1.36008 8.8891 1.11133 9.13785 1.11133 9.4447C1.11133 9.75155 1.36008 10.0003 1.66692 10.0003Z",
    fill: "#B9B9B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88958 10.0003C4.19643 10.0003 4.44518 9.75155 4.44518 9.4447C4.44518 9.13785 4.19643 8.8891 3.88958 8.8891C3.58273 8.8891 3.33398 9.13785 3.33398 9.4447C3.33398 9.75155 3.58273 10.0003 3.88958 10.0003Z",
    fill: "#B9B9B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11224 10.0003C6.41908 10.0003 6.66783 9.75155 6.66783 9.4447C6.66783 9.13785 6.41908 8.8891 6.11224 8.8891C5.80539 8.8891 5.55664 9.13785 5.55664 9.4447C5.55664 9.75155 5.80539 10.0003 6.11224 10.0003Z",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBathRoom);
export default __webpack_public_path__ + "static/media/card-bath-room.0972636a1190e7bdb5731ef8cd27c697.svg";
export { ForwardRef as ReactComponent };